<template>
  <SoSummaryTable :items="refundReviewSummary" />
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { AccountService } from "@/services/AccountService"
  import SoSummaryTable from "@/components/SoSummaryTable.vue"
  import {
    SoSummaryTableValueType,
    SoSummaryTableItem,
  } from "@/types/components/SoSummaryTable"

  export default defineComponent({
    components: {
      SoSummaryTable,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
      }
    },
    computed: {
      refundReviewSummary(): SoSummaryTableItem[] {
        return [
          {
            type: SoSummaryTableValueType.BALANCE,
            title: "Account Balance",
            value: this.current.account.data.balance,
          },
          {
            type: SoSummaryTableValueType.MONEY,
            title: "Unbilled Readings Usage",
            value: AccountService.getUnbilledReadingCosts(
              this.current.coreId.data,
            ).data,
          },
          {
            type: SoSummaryTableValueType.BALANCE,
            title: "Balance Including Last Readings",
            value:
              AccountService.getUnbilledReadingCosts(this.current.coreId.data)
                .data + this.current.account.data.balance,
          },
          {
            type: SoSummaryTableValueType.MONEY,
            title: "Max Refund",
            value: this.current.refundEligibility.data.maxRefundAmount,
          },
        ]
      },
    },
  })
</script>
